import { useEffect } from 'react';

function useNativeListener(
    functionName: string,
    fn: Function,
    deps?: any[],
    noClear?: boolean,
) {
    useEffect(() => {
        // @ts-ignore
        window[functionName] = fn;
        return () => {
            if (!noClear) {
                // @ts-ignore
                window[functionName] = undefined;
            }
        };
    }, deps || []);
}

export default useNativeListener;
